module.exports = __webpack_public_path__ + "static/media/worthington field.b4e3d225.jpeg";